import React from 'react';
import ItemImage from './ItemImage';
import { FULFILLMENT_TYPE } from '../../constants/status';
import BuyItAgainButton from '../buy-it-again/BuyItAgainButton';
var SummaryItem = function (_a) {
    var item = _a.item, isMilitaryExchangeGuest = _a.isMilitaryExchangeGuest;
    var price = item.itemCost.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    var totalPrice = (item.returnQuantity * item.itemCost).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-flex sui-mb-4 sui-mt-6", "data-testid": "item-div" },
            React.createElement(ItemImage, { itemDescription: item === null || item === void 0 ? void 0 : item.itemDescription, imageUrl: item === null || item === void 0 ? void 0 : item.imageUrl, margin: true }),
            React.createElement("div", { className: "sui-flex sui-flex-col sui-items-start" },
                React.createElement("div", null,
                    React.createElement("span", { className: "sui-font-bold sui-pr-1" }, item === null || item === void 0 ? void 0 : item.brandName),
                    React.createElement("span", null, item === null || item === void 0 ? void 0 : item.itemDescription)),
                React.createElement("div", { className: "sui-mt-2" },
                    "Qty: ", item === null || item === void 0 ? void 0 :
                    item.returnQuantity),
                item.itemCost !== 0 && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "sui-mt-2 sui-font-bold", "data-testid": "total-price-div" },
                        "$",
                        totalPrice),
                    (item === null || item === void 0 ? void 0 : item.returnQuantity) > 1 && (React.createElement("div", { "data-testid": "single-price-div" }, "($".concat(price, "/item)"))))))),
        !isMilitaryExchangeGuest && (React.createElement(BuyItAgainButton, { quantity: item === null || item === void 0 ? void 0 : item.returnQuantity, itemId: item === null || item === void 0 ? void 0 : item.omsId, fulfillmentLocation: "DirectShip", fulfillmentType: FULFILLMENT_TYPE.STH, subscriptionDefaultFrequency: "3_3" }))));
};
export default SummaryItem;
